function ActionItemDetail() {
    return ( <>
    This is Active Item Detail Page
    </> );
}

export default ActionItemDetail;